import React, { ReactElement } from 'react';

export default function AssetValidationHelp(): ReactElement {
  return (
    <div data-awsui-column-layout-root="true">
      <div className="awsui-util-help-panel">
        <div className="awsui-util-help-panel-header">Asset Validation help</div>
        <p>
          <h3>Power and Cooling (PAC) Validation</h3>
          Check if all data is correct and fill in the required fields. Click validate if all data
          is correct. otherwise click Create exception.
        </p>
        <p>
          <strong>Asset category</strong>: The Amazon defined categorization of this equipment.
        </p>
        <p>
          <strong>Location</strong>: What area or room the equipment is located in.
        </p>
        <p>
          <strong>Make</strong>: The company that manufactures the equipment.
        </p>
        <p>
          <strong>Model</strong>: The manufacturer&apos;s identifier for the product line.
        </p>
        <p>
          <strong>Serial number</strong>: The manufacturer&apos;s unique identifier for the
          equipment.
        </p>
        <p>
          <strong>Current status</strong>: Designates whether the equipment is installed for use
          (In-Service) or a spare part (In-Stores).
        </p>
        <p>
          <strong>Yellow asset tag ID</strong>: The Amazon unique identifier for the equipment.
        </p>
      </div>
    </div>
  );
}
